import {makeRequest} from "../api-client";

const middlewareUrl = process.env.MIDDLEWARE_URL

export const login = (username, otp) => {
    return makeRequest(middlewareUrl + "/lombard/login", "POST", {
        "username": username,
        "password": otp
    }, {
        'x-client-id': process.env.CLIENT_ID
    }, "FETCH_USER")
};

export const logout = () => {
    return makeRequest(middlewareUrl + "/lombard/logout", "DELETE", null,
        {
            'x-environment': 'internal-live',
            'x-client-id': process.env.CLIENT_ID
        }, "LOGOUT")
}


export const getTokenDetails = () => {
    return makeRequest(middlewareUrl + "/token", "GET", null, {
        'x-environment': 'internal-live',
        'x-client-id': process.env.CLIENT_ID
    }, "GET_TOKEN_DETAILS")
};

export const getTokenList = (page, pageSize, sortObj, sortType) => {
    let headers = {
        'x-environment': 'internal-live',
        'x-client-id': process.env.CLIENT_ID,
        'x-meta-page-size': pageSize,
        'x-meta-page': page
    }

    if (sortObj && sortType) {
        let sortString = sortObj + '#' + sortType
        headers['x-meta-sort-order'] = sortString
    }
    return makeRequest(middlewareUrl + "/lombard/token/list", "GET", null, headers, "GET_TOKEN_LIST")
};


export const revokeTokenByValue = (value) => {
    return makeRequest(middlewareUrl + "/lombard/revoke/consent/token", "DELETE", {tokenToRevoke: value},
        {
        'x-client-id': process.env.CLIENT_ID
        }, "REVOKE_TOKEN_BY_VALUE")
};


export const submitPayment = (jwt, loginId, token) => {
    return makeRequest(middlewareUrl + "/lombard/submit/payment", "POST", {
        "jwt": jwt,
        "loginId": loginId,
        "token": token,
        "x-client-id": process.env.CLIENT_ID
    }, {}, "SUBMIT_PAYMENT")
};

export const submitSandboxPayment = (jwt) => {
    return makeRequest(middlewareUrl + "/lombard/submit/sandbox/payment", "POST", {
        "jwt": jwt,
        "loginId": " ",
        "token": " ",
        "x-client-id": process.env.CLIENT_ID
    }, {}, "SUBMIT_PAYMENT")
};


